import { useState } from 'react';

export const useNetworkUI = () => {
  const [expandedNetworks, setExpandedNetworks] = useState<Record<string, boolean>>({});
  const [dragOverNetworkId, setDragOverNetworkId] = useState<string | null>(null);

  const toggleNetworkExpansion = (networkId: string) => {
    setExpandedNetworks((prev) => ({
      ...prev,
      [networkId]: !prev[networkId],
    }));
  };

  const expandNetwork = (networkId: string) => {
    setExpandedNetworks((prev) => ({
      ...prev,
      [networkId]: true,
    }));
  };

  const handleDragOver = (e: React.DragEvent, networkId: string) => {
    e.preventDefault();
    setDragOverNetworkId(networkId);
  };

  const handleDragLeave = () => {
    setDragOverNetworkId(null);
  };

  const handleDrop = (
    e: React.DragEvent,
    networkId: string,
    onFilesDropped: (networkId: string, files: FileList) => void
  ) => {
    e.preventDefault();
    setDragOverNetworkId(null);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onFilesDropped(networkId, e.dataTransfer.files);
    }
  };

  return {
    expandedNetworks,
    dragOverNetworkId,
    toggleNetworkExpansion,
    expandNetwork,
    handleDragOver,
    handleDragLeave,
    handleDrop,
  };
};
